import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import { uploadFile, downloadXLSFile } from "utils/api";
import { defaultReturn, makePayload, generateDefaultActions, subKeySaga, requestSaga, fillDictionary } from "store/utils/helpers";
import { ToastSuccess, ToastError, ToastInfo } from "components/Global/Toasts/Toasty";
import { CLEAR_STORE_SOFT } from "pages/deal/deal.store";

export const GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS = generateDefaultActions("GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS");
export const GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY = generateDefaultActions("GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY");
export const GET_PIPELINE_DEAL_LOAN_COUNTS = generateDefaultActions("GET_PIPELINE_DEAL_LOAN_COUNTS");
export const GET_LOAN_BY_ID = generateDefaultActions("GET_LOAN_BY_ID");
export const ADD_FILE_TO_LOAN = generateDefaultActions("ADD_FILE_TO_LOAN");
export const GET_LOAN_FILES = generateDefaultActions("GET_LOAN_FILES");
export const DELETE_LOAN_FILE = generateDefaultActions("DELETE_LOAN_FILE");
export const LOAN_ADD = generateDefaultActions("LOAN_ADD");
export const CLEAR_EDIT_LOAN = generateDefaultActions("CLEAR_EDIT_LOAN");
export const CLEAR_LOAN_COUNT = generateDefaultActions("CLEAR_LOAN_COUNT");
export const UPDATE_LOAN_STATUS = generateDefaultActions("UPDATE_LOAN_STATUS");
export const DOWNLOAD_DEAL_QUOTES = generateDefaultActions("DOWNLOAD_DEAL_QUOTES");

export const DOWNLOAD_LOAN_COMPARISON = generateDefaultActions("DOWNLOAD_LOAN_COMPARISON");
export const GET_LOANS_FOR_COMPARISON = generateDefaultActions("GET_LOANS_FOR_COMPARISON");
// export const COMBINE_LOANS_FOR_COMPARISON = generateDefaultActions("COMBINE_LOANS_FOR_COMPARISON");

export const ADD_NOTE_TO_LOAN = generateDefaultActions("ADD_NOTE_TO_LOAN");
export const GET_LOAN_NOTES = generateDefaultActions("GET_LOAN_NOTES");
export const DELETE_LOAN_NOTES = generateDefaultActions("DELETE_LOAN_NOTES");
export const BULK_REJECT_SUBORDINATE_QUOTES = generateDefaultActions("BULK_REJECT_SUBORDINATE_QUOTES");
export const CLEAR_STORE = generateDefaultActions("CLEAR_STORE");

export const CLEAR_LOAN_BY_ID = "CLEAR_LOAN_BY_ID";

const initialState = {
  lastCreatedClone: null,
  loansByStatus: [],
  loansByPreference: {},
  loanCounts: {
    senior: 0,
    mezz: 0,
    supplemental: 0,
    rejected: 0,
    lenderPassed: 0
  },
  loanFiles: [],
  loansForComparison: [],
  combinedLoansForComparison: [],
  loanNotes: [],
  editLoan: {},
  loanLosingPRQuotes: {
    lender_passed_loan_table: null,
    rejected_loan_table: null
  },
  quoteMetricAnalysis: [],
  loanProceedAssumptions: null,
  loanProceedAssumptionsForDeal: null
};

export default function loanReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case CLEAR_STORE.success:
    case CLEAR_STORE_SOFT.success:
      return initialState;

    case UPDATE_EXTENSIONS.success:
      ToastSuccess("Updated");

      return state;
    case SAVE_LOAN_PROCEED_ASSUMPTIONS.success:
      ToastSuccess("Save Success");

      return state;
    case GET_LOAN_PROCEED_ASSUMPTIONS.success:
      return defaultReturn(state, payload.data, "loanProceedAssumptions");
    case GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID.success:
      const loanProceedAssumptions = payload.data ? payload.data[0] : "Not Set";

      return fillDictionary(state, loanProceedAssumptions, "loanProceedAssumptionsForDeal", subKey);
    case UPDATE_LOAN_STATUS.success:
      return defaultReturn(state, payload.clonedLoan, "lastCreatedClone");
    case GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS.success:
      return fillDictionary(state, payload, "loansByPreference", subKey);
    case GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY.success:
      return fillDictionary(state, payload, "loansByPreference", subKey);
    case LOAN_ADD.success:
      ToastSuccess("Save successful");

      return defaultReturn(state, payload, "editLoan");
    case CLEAR_EDIT_LOAN.success:
      return defaultReturn(state, {}, "editLoan");
    case CLEAR_LOAN_COUNT.success:
      return defaultReturn(
        state,
        {
          senior: 0,
          mezz: 0,
          supplemental: 0,
          rejected: 0,
          lenderPassed: 0
        },
        "loanCounts"
      );
    case GET_LOAN_FILES.success:
      return fillDictionary(state, payload.data, "loanFiles", subKey);
    case GET_LOAN_BY_ID.success:
      return defaultReturn(state, payload, "editLoan");
    case GET_LOAN_BY_ID.failure:
      return defaultReturn(state, { data: payload.response.status }, "editLoan");
    case CLEAR_LOAN_BY_ID:
      return defaultReturn(state, null, "editLoan");

    case GET_LOANS_FOR_COMPARISON.success:
      ToastSuccess("Quote Analysis Complete");

      return defaultReturn(state, payload.result, "quoteMetricAnalysis");
    case GET_LOANS_FOR_COMPARISON.failure:
      return defaultReturn(state, "ERROR", "quoteMetricAnalysis");
    case GET_LOANS_FOR_COMPARISON_CLEAN.success:
      return defaultReturn(state, payload, "quoteMetricAnalysis");

    case GET_LOAN_NOTES.success:
    case DELETE_LOAN_NOTES.success:
      return fillDictionary(state, payload.data, "loanNotes", subKey);
    case GET_PIPELINE_DEAL_LOAN_COUNTS.success:
      return defaultReturn(state, payload.data, "loanCounts");
    case GET_LOANS_BY_DEAL_AND_STATUS.success:
      return fillDictionary(state, payload, "loansByStatus", subKey);
    case LOAN_LOSING_PR_QUOTES.success:
      return fillDictionary(state, payload, "loanLosingPRQuotes", subKey);
    case GET_LOAN_MODIFICATION_HISTORY.success:
      const loanModificationHistory = state.loanModificationHistory || {};
      loanModificationHistory[payload.data.primaryLoanId] = payload.data.loans;

      return { ...state, loanModificationHistory };
    case APPLY_TO_EXISTING_FINANCING.success:
      ToastSuccess("Assumptions updated for existing financing.");

      return state;
    case APPLY_TO_EXISTING_FINANCING.failure:
      ToastError("Could not update financing.");

      return state;
    case DELETE_LOAN_BY_ID.success:
      ToastSuccess("Deleted");
    default:
      return state;
  }
}

export const GET_LOAN_MODIFICATION_HISTORY = generateDefaultActions("GET_LOAN_MODIFICATION_HISTORY");
export const getLoanModificationHistory = (dealId, loanId) => makePayload(GET_LOAN_MODIFICATION_HISTORY.value, { dealId, loanId });
function* getLoanModificationHistorySaga(payload) {
  const url = `/getLoanModificationHistory/${payload.dealId}/${payload.loanId}`;
  yield requestSaga(GET_LOAN_MODIFICATION_HISTORY, url, "GET");
}

export const GET_LOAN_PROCEED_ASSUMPTIONS = generateDefaultActions("GET_LOAN_PROCEED_ASSUMPTIONS");
export const getLoanProceedAssumptions = payload => makePayload(GET_LOAN_PROCEED_ASSUMPTIONS.value, payload);
function* getLoanProceedAssumptionsSaga(payload) {
  const url = "/loan/getLoanProceedAssumptions";
  yield requestSaga(GET_LOAN_PROCEED_ASSUMPTIONS, url, "POST", payload);
}

export const GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID = generateDefaultActions("GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID");
export const getLoanProceedAssumptionsByDealId = payload => makePayload(GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID.value, payload);
function* getLoanProceedAssumptionsByDealIdSaga(payload) {
  const url = "/loan/getLoanProceedAssumptionsByDealId";
  const requestSaga = subKeySaga(payload.dealId);
  yield requestSaga(GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID, url, "POST", payload);
}

export const SAVE_LOAN_PROCEED_ASSUMPTIONS = generateDefaultActions("SAVE_LOAN_PROCEED_ASSUMPTIONS");
export const saveLoanProceedAssumptions = payload => makePayload(SAVE_LOAN_PROCEED_ASSUMPTIONS.value, payload);
function* saveLoanProceedAssumptionsSaga(payload) {
  const url = "/loan/saveLoanProceedAssumptions";
  yield requestSaga(SAVE_LOAN_PROCEED_ASSUMPTIONS, url, "POST", payload);
}

export const APPLY_TO_EXISTING_FINANCING = generateDefaultActions("APPLY_TO_EXISTING_FINANCING");
export const applyToExistingFinancing = payload => makePayload(APPLY_TO_EXISTING_FINANCING.value, payload);
function* applyToExistingFinancingSaga(payload) {
  const url = "/loan/applyToExistingFinancing";
  yield requestSaga(APPLY_TO_EXISTING_FINANCING, url, "POST", payload);
}

export const UPDATE_EXTENSIONS = generateDefaultActions("UPDATE_EXTENSIONS");
export const updateExtensions = payload => makePayload(UPDATE_EXTENSIONS.value, payload);
function* updateExtensionsSaga(payload) {
  const url = "/loan/updateExtensions";
  yield requestSaga(UPDATE_EXTENSIONS, url, "POST", payload);
}

export const DOWNLOAD_EXTENSIONS = generateDefaultActions("DOWNLOAD_EXTENSIONS");
export const downloadExtensions = payload => makePayload(DOWNLOAD_EXTENSIONS.value, payload);
function* downloadExtensionsSaga(payload) {
  const url = "/downloadExtensions";
  yield call(downloadXLSFile, url, "POST", payload);
}

export const DOWNLOAD_LOAN_MODIFICATION_HISTORY = generateDefaultActions("DOWNLOAD_LOAN_MODIFICATION_HISTORY");
export const downloadLoanModificationHistory = (dealId, loanId) => makePayload(DOWNLOAD_LOAN_MODIFICATION_HISTORY.value, { dealId, loanId });
function* downloadLoanModificationHistorySaga(payload) {
  const url = `/downloadLoanModificationHistory/${payload.dealId}/${payload.loanId}`;
  yield call(downloadXLSFile, url, "GET");
}

/**
 * Get all loans
 * @return {Object} Action
 */
export const getLoansByPreferenceAndLoanStatus = payload => makePayload(GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS.value, payload);
export const getLoansByPreferenceAndLoanSeniority = payload => makePayload(GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY.value, payload);
export const addLoan = payload => makePayload(LOAN_ADD.value, payload);
export const getPipelineDealLoanCounts = payload => makePayload(GET_PIPELINE_DEAL_LOAN_COUNTS.value, payload);
export const addFileToLoan = (model, modelId, file) => ({
  type: ADD_FILE_TO_LOAN.value,
  model,
  modelId,
  file,
  url: "/files"
});
export const getLoanFiles = payload => makePayload(GET_LOAN_FILES.value, payload);
export const deleteLoanFile = payload => makePayload(DELETE_LOAN_FILE.value, payload);
export const getLoanById = payload => makePayload(GET_LOAN_BY_ID.value, payload);
export const clearEditLoan = payload => makePayload(CLEAR_LOAN_BY_ID, payload);
export const updateLoanStatusById = payload => makePayload(UPDATE_LOAN_STATUS.value, payload);
export const bulkRejectSubordinateQuotes = payload => makePayload(BULK_REJECT_SUBORDINATE_QUOTES.value, payload);
export const clearLoan = payload => makePayload(CLEAR_EDIT_LOAN.value, payload);
export const clearLoanCount = payload => makePayload(CLEAR_LOAN_COUNT.value, payload);
export const downloadDealQuotes = payload => makePayload(DOWNLOAD_DEAL_QUOTES.value, payload);

export const DOWNLOAD_QUOTES = generateDefaultActions("DOWNLOAD_QUOTES");
export const downloadQuotes = payload => makePayload(DOWNLOAD_QUOTES.value, payload);
function* downloadQuotesSaga(payload) {
  const url = "downloadQuotes";
  const sendPayload = {
    dealId: payload.dealId
  };
  yield call(downloadXLSFile, url, "POST", sendPayload, "Quotes");
}

export const DOWNLOAD_QUOTES_AS_GUEST = generateDefaultActions("DOWNLOAD_QUOTES_AS_GUEST");
export const downloadQuotesAsGuest = payload => makePayload(DOWNLOAD_QUOTES_AS_GUEST.value, payload);
function* downloadQuotesAsGuestSaga(payload) {
  const url = "/downloadQuotesAsAGuest";
  const sendPayload = {
    dealId: payload.dealId
  };
  yield call(downloadXLSFile, url, "POST", sendPayload, "Quotes");
}

export const downloadLoansForComparison = payload => makePayload(DOWNLOAD_LOAN_COMPARISON.value, payload);
export const getLoansForComparison = payload => makePayload(GET_LOANS_FOR_COMPARISON.value, payload);

export const addNoteToLoan = (model, modelId, note) => ({
  type: ADD_NOTE_TO_LOAN.value,
  model,
  modelId,
  note,
  url: "/notes"
});
export const getLoanNotes = payload => makePayload(GET_LOAN_NOTES.value, payload);
export const deleteNote = payload => makePayload(DELETE_LOAN_NOTES.value, payload);

// Saga

function* getLoansByPreferenceAndLoanStatusSaga(payload) {
  const url = "/getLoansByPreference/byStatus";
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.type;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS, url, "POST", filteredPayload);
}

function* getLoansByPreferenceAndLoanSenioritySaga(payload) {
  const url = "/getLoansByPreference/bySeniority";
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.type;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY, url, "POST", filteredPayload);
}

function* addFileToLoanSaga(payload) {
  try {
    const response = yield call(uploadFile, payload);
    yield put(ADD_FILE_TO_LOAN.createSuccess(response));
    ToastSuccess("File Uploaded Successfully");
    yield getLoanFilesSaga({
      modelName: "loan",
      modelId: payload.modelId,
      subKey: payload.modelId
    });
  } catch (error) {
    yield put(ADD_FILE_TO_LOAN.createFailure(error));
    ToastError(`Upload Failed: ${error.message}`);
  }
}

function* getLoanFilesSaga(payload) {
  const url = "/getFiles/byModel";
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_LOAN_FILES, url, "POST", payload);
}

function* deleteLoanFileSaga(payload) {
  const url = `/files/${payload.fileId}`;
  yield requestSaga(DELETE_LOAN_FILE, url, "DELETE");
  if (payload.shouldUpdateAfter) {
    yield getLoanFilesSaga({
      modelId: payload.modelId,
      modelName: payload.modelName,
      subKey: payload.subKey
    });
  }
}

function* addLoanSaga(payload) {
  const url = "/loans/new";

  const callback = payload.callback;
  delete payload.callback;

  if (payload) {
    for (const key in payload.loan) {
      if (payload.loan[key] === "") {
        payload.loan[key] = null;
      }
    }
  }

  yield requestSaga(LOAN_ADD, url, "POST", payload);
  if (payload.shouldClearLoan) {
    yield put({
      type: CLEAR_EDIT_LOAN.success
    });
  }
  if (callback) {
    callback();
  }
}

function* getPipelineDealLoanCountsSaga(payload) {
  const url = "/getPipelineDealLoanCounts";
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.type;
  yield requestSaga(GET_PIPELINE_DEAL_LOAN_COUNTS, url, "POST", filteredPayload);
}

function* getLoanByIdSaga(payload) {
  const url = `/loans/${payload.loanId}`;
  yield requestSaga(GET_LOAN_BY_ID, url, "GET");
}

function* updateLoanStatusByIdSaga(payload) {
  const url = "/loan/updateStatus/";
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.callback;

  yield requestSaga(UPDATE_LOAN_STATUS, url, "POST", filteredPayload);
  payload.callback();
}

function* bulkRejectSubordinateQuotesSaga(payload) {
  const url = "/loan/bulkRejectSubordinateQuotes/";
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.callback;

  yield requestSaga(BULK_REJECT_SUBORDINATE_QUOTES, url, "POST", filteredPayload);
  payload.callback();
}

function* clearLoanSaga(payload) {
  yield put({
    type: CLEAR_EDIT_LOAN.success
  });
}
function* clearLoanCountSaga(payload) {
  yield put({
    type: CLEAR_LOAN_COUNT.success
  });
  if (payload.callback) {
    payload.callback();
  }
}

function* downloadDealQuotesSaga(payload) {
  const url = "downloaddealquotes";
  yield call(downloadXLSFile, url, "POST", payload);
}

function* downloadLoansForComparisonSaga(payload) {
  const url = "downloadLoansForComparison";
  yield call(downloadXLSFile, url, "POST", payload, "QuoteComparison");
}

function* getLoansForComparisonSaga(payload) {
  const url = payload.recalculate ? "/getLoansForComparisonRecalculation" : "/getLoansForComparison";
  if (payload.showProgress) {
    yield put(clearQuoteMetricAnalysis());
  } else {
    ToastInfo("Calculating");
  }
  yield requestSaga(GET_LOANS_FOR_COMPARISON, url, "POST", payload);
}

export const GET_LOANS_FOR_COMPARISON_CLEAN = generateDefaultActions("GET_LOANS_FOR_COMPARISON_CLEAN");
function clearQuoteMetricAnalysis() {
  return {
    type: GET_LOANS_FOR_COMPARISON_CLEAN.success,
    payload: []
  };
}

function* addNoteToLoanSaga(payload) {
  const url = "/loan/addnote";
  const note = {
    model: "loan",
    modelId: payload.modelId,
    note: payload.note,
    pinned: false
  };

  yield requestSaga(ADD_NOTE_TO_LOAN, url, "POST", {
    note
  });
  ToastSuccess("Note Added Successfully");
  yield getLoanNotesSaga({
    modelName: "loan",
    modelId: payload.modelId,
    subKey: payload.modelId
  });
}

function* getLoanNotesSaga(payload) {
  const url = `/loans/notes/${payload.modelId}`;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_LOAN_NOTES, url, "GET");
}

function* deleteNoteSaga(payload) {
  const { noteId, modelName, modelId } = payload;
  try {
    const url = `/notes/${noteId}?modelName=${modelName}&modelId=${modelId}`;
    const requestSaga = subKeySaga(payload.subKey);
    yield requestSaga(DELETE_LOAN_NOTES, url, "DELETE");
    ToastSuccess("Note Deleted");
  } catch (error) {
    ToastError(`Deleting Note Failed: ${error.message}`);
  }
}

function clearLoansByDealIdAndStatus(payload, subKey) {
  return {
    type: GET_LOANS_BY_DEAL_AND_STATUS.success,
    payload,
    subKey
  };
}

export const GET_LOANS_BY_DEAL_AND_STATUS = generateDefaultActions("GET_LOANS_BY_DEAL_AND_STATUS");
export const getLoansByDealIdAndStatus = payload => makePayload(GET_LOANS_BY_DEAL_AND_STATUS.value, payload);
function* getLoansByDealIdAndStatusSaga(payload) {
  const { dealId, loanStatusId } = payload;
  try {
    if (!dealId) {
      yield put(clearLoansByDealIdAndStatus({}, loanStatusId));
    } else {
      const url = `/loans/getLoansByDealIdAndStatus/${dealId}/${loanStatusId}`;
      const requestSaga = subKeySaga(loanStatusId);
      yield requestSaga(GET_LOANS_BY_DEAL_AND_STATUS, url, "GET");
    }
  } catch (error) {
    ToastError("Error Selecting Loans");
  }
}

// Loan Losing Pass Rejected Quotes View and Download
export const LOAN_LOSING_PR_QUOTES = generateDefaultActions("LOAN_LOSING_PR_QUOTES");
export const getLoanLosingPRQuotes = payload => makePayload(LOAN_LOSING_PR_QUOTES.value, payload);
function* getLoanLosingPRQuotesSaga(payload) {
  const url = "/loans/getLoanLosingPRQuotes";
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.type;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(LOAN_LOSING_PR_QUOTES, url, "POST", filteredPayload);
}

export const LOAN_LOSING_PR_QUOTES_DOWNLOAD = generateDefaultActions("LOAN_LOSING_PR_QUOTES_DOWNLOAD");
export const downloadLoanLosingPRQuotes = payload => makePayload(LOAN_LOSING_PR_QUOTES_DOWNLOAD.value, payload);
function* downloadLoanLosingPRQuotesSaga(payload) {
  const url = "loans/downloadLoanLosingPRQuotes";
  yield call(downloadXLSFile, url, "POST", payload, "");
}
// Loan Losing Pass Rejected Quotes View and Download

// DELETE_LOAN_BY_ID
export const DELETE_LOAN_BY_ID = generateDefaultActions("DELETE_LOAN_BY_ID");
export const deleteLoanById = payload => makePayload(DELETE_LOAN_BY_ID.value, payload);
function* deleteLoanByIdSaga(payload) {
  yield requestSaga(DELETE_LOAN_BY_ID, `/loans/${payload.loanId}`, "DELETE");
  if (payload.callback) {
    payload.callback();
  }
}

export function* loanSaga() {
  yield takeEvery(GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS.value, getLoansByPreferenceAndLoanStatusSaga);
  yield takeEvery(GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY.value, getLoansByPreferenceAndLoanSenioritySaga);
  yield takeLatest(GET_LOAN_MODIFICATION_HISTORY.value, getLoanModificationHistorySaga);
  yield takeLatest(DOWNLOAD_LOAN_MODIFICATION_HISTORY.value, downloadLoanModificationHistorySaga);
  yield takeLatest(LOAN_ADD.value, addLoanSaga);
  yield takeLatest(ADD_FILE_TO_LOAN.value, addFileToLoanSaga);
  yield takeEvery(GET_LOAN_FILES.value, getLoanFilesSaga);
  yield takeLatest(DELETE_LOAN_FILE.value, deleteLoanFileSaga);
  yield takeLatest(GET_LOAN_BY_ID.value, getLoanByIdSaga);
  yield takeLatest(UPDATE_LOAN_STATUS.value, updateLoanStatusByIdSaga);
  yield takeLatest(CLEAR_EDIT_LOAN.value, clearLoanSaga);
  yield takeLatest(CLEAR_LOAN_COUNT.value, clearLoanCountSaga);
  yield takeLatest(DOWNLOAD_DEAL_QUOTES.value, downloadDealQuotesSaga);
  yield takeLatest(DOWNLOAD_QUOTES.value, downloadQuotesSaga);
  yield takeLatest(DOWNLOAD_LOAN_COMPARISON.value, downloadLoansForComparisonSaga);
  yield takeLatest(GET_LOANS_FOR_COMPARISON.value, getLoansForComparisonSaga);
  yield takeLatest(ADD_NOTE_TO_LOAN.value, addNoteToLoanSaga);
  yield takeLatest(GET_LOAN_NOTES.value, getLoanNotesSaga);
  yield takeLatest(DELETE_LOAN_NOTES.value, deleteNoteSaga);
  yield takeLatest(GET_PIPELINE_DEAL_LOAN_COUNTS.value, getPipelineDealLoanCountsSaga);
  yield takeLatest(GET_LOANS_BY_DEAL_AND_STATUS.value, getLoansByDealIdAndStatusSaga);
  yield takeLatest(LOAN_LOSING_PR_QUOTES.value, getLoanLosingPRQuotesSaga);
  yield takeLatest(LOAN_LOSING_PR_QUOTES_DOWNLOAD.value, downloadLoanLosingPRQuotesSaga);
  yield takeLatest(DOWNLOAD_QUOTES_AS_GUEST.value, downloadQuotesAsGuestSaga);
  yield takeLatest(BULK_REJECT_SUBORDINATE_QUOTES.value, bulkRejectSubordinateQuotesSaga);
  yield takeLatest(DELETE_LOAN_BY_ID.value, deleteLoanByIdSaga);
  yield takeLatest(GET_LOAN_PROCEED_ASSUMPTIONS.value, getLoanProceedAssumptionsSaga);
  yield takeLatest(GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID.value, getLoanProceedAssumptionsByDealIdSaga);
  yield takeLatest(SAVE_LOAN_PROCEED_ASSUMPTIONS.value, saveLoanProceedAssumptionsSaga);
  yield takeLatest(UPDATE_EXTENSIONS.value, updateExtensionsSaga);
  yield takeLatest(DOWNLOAD_EXTENSIONS.value, downloadExtensionsSaga);
  yield takeLatest(APPLY_TO_EXISTING_FINANCING.value, applyToExistingFinancingSaga);
}
